import native from "src/constants/native";
import { paddingLarge, paddingMedium } from "./spacing";

const DiscStyles = {
	backgroundColor: "#0F1117",
	shadowColor: "#DCDCDC",
	shadowOpacity: native ? 0.2 : 0.4,
	shadowRadius: native ? paddingMedium : paddingLarge,
};
export default DiscStyles;
